import { useEffect, useState } from "react";

// web-rnw twin of ./useFinePointer.ts: the primary pointer is fine (a mouse,
// a trackpad), not a finger. Follows the query when a mouse is plugged in.
// This package compiles without the DOM lib: the little used is declared here.
type Query = {
  matches: boolean;
  addEventListener?: (type: "change", fn: () => void) => void;
  removeEventListener?: (type: "change", fn: () => void) => void;
};
declare const window: { matchMedia?: (q: string) => Query } | undefined;

const QUERY = "(pointer: fine)";
const query = (): Query | undefined => (typeof window === "undefined" ? undefined : window.matchMedia?.(QUERY));

export function useFinePointer(): boolean {
  const [fine, setFine] = useState(() => query()?.matches === true);
  useEffect(() => {
    const q = query();
    if (!q) return;
    const sync = () => setFine(q.matches);
    sync();
    q.addEventListener?.("change", sync);
    return () => q.removeEventListener?.("change", sync);
  }, []);
  return fine;
}
